import { MAX_PLAN_DESCRIPTION_LENGTH } from '@db/Plans/Validators';
import db, { parseFirestoreDoc } from '@helpers/firebase/Firestore';
import { Plan } from '@types';

export function parsePlanDoc(doc: db.DocumentSnapshot) {
  return parseFirestoreDoc<Plan>(doc, 'planId');
}

type FormatPlanInput = {
  description?: Plan['description'];
  notes?: Plan['notes'];
};

export function formatPlanInput<T extends FormatPlanInput>({ description, notes, ...rest }: T) {
  return {
    ...rest,
    description: description ? description.trim().slice(0, MAX_PLAN_DESCRIPTION_LENGTH) : '',
    notes: notes ? notes.trim() : '',
  };
}
